import { call, put, select, takeLatest } from 'redux-saga/effects'

import { ToastTemplateWarning } from '@components/UI/ToastTemplate'
import { ResponseError } from '@lib/error'
import { selectAuthToken } from '@store/auth'
import {
  IShortlistShareLinkResponse,
  requestShortlistShareLink,
  RequestShortlistShareLinkActionTypes,
  requestShortlistShareLinkError,
  requestShortlistShareLinkSuccess,
  selectShortlistShareLink,
} from '@store/campaigns'
import { Toaster } from '@tribegroup'
import { networkRequest } from '@utils'

export function* handleRequestShortlistShareLink(
  action: ReturnType<typeof requestShortlistShareLink>,
) {
  const { campaignId } = action.payload

  try {
    const link = yield select(selectShortlistShareLink, campaignId)

    // Guards a race between the button's enabled-check and this saga running: the
    // link can be cleared from the store (e.g. a background campaign refetch) in the
    // window between the click and this select. Throwing a well-shaped ResponseError
    // (rather than letting `link.method` below throw a raw TypeError) keeps the
    // dispatched error correctly typed as IResponseError.
    if (!link) {
      throw new ResponseError({ error: 'No shortlist share link available' }, 404)
    }

    const authToken = yield select(selectAuthToken)

    const response: IShortlistShareLinkResponse = yield call(
      networkRequest,
      link.method,
      link.href,
      undefined,
      authToken,
    )

    yield put(requestShortlistShareLinkSuccess(campaignId, response))
  } catch (error) {
    yield put(requestShortlistShareLinkError(campaignId, error))
    yield call(Toaster.createToast, ToastTemplateWarning, {
      i18nKey: 'campaignCreators.shareWithCustomer.toast.error',
    })
  }
}

export function* watchRequestShortlistShareLinkRequest() {
  yield takeLatest(
    RequestShortlistShareLinkActionTypes.REQUEST_SHORTLIST_SHARE_LINK_REQUEST,
    handleRequestShortlistShareLink,
  )
}
